"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusDevice = void 0;
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const events_1 = require("events");
const nexus_1 = require("../pipes/nexus");
const nexus_parsers_1 = require("../lib/nexus-parsers");
const nexus_utils_1 = require("../lib/nexus-utils");
const c = __importStar(require("../lib/constants"));
const rxjs_1 = require("rxjs");
// TODO: move
class NexusDevice extends events_1.EventEmitter {
    constructor() {
        super();
        this.active = new rxjs_1.BehaviorSubject(false);
        this.eeg = nexus_1.eeg(this);
        this.telemetry = nexus_1.telemetry(this);
        this.accel = nexus_1.accel(this);
        this.gyro = nexus_1.gyro(this);
        this.ppg = nexus_1.ppg(this);
    }
    async setConfig(device) {
        this.eegConfig = {
            samplingRate: 255,
            bias: 1,
            gains: Array.from(c.INSAI_EEG_CHANNELS).map((_) => 32),
            impedance: 0,
        };
        const { samplingRate, bias, gains, impedance } = this.eegConfig;
        const cmd = [[1, samplingRate, bias], gains, impedance].flat();
        const start = new Uint8Array(cmd);
        const view = new DataView(start.buffer);
        await nexus_utils_1.write(device.deviceId, view);
    }
    async startStreams(device, config = true) {
        // notifications for telemetry and biometrics needs to be initiated before start command
        // TODO: firmware – separate datastreams into separate characteristics
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, c.INSAI_SERVICE, c.INSAI_MOTION_CHARACTERISTIC, (v) => {
            this.emit('misc', v);
            nexus_parsers_1.parseAccel(v).map((a) => this.emit('accel', a));
            nexus_parsers_1.parseGyro(v).map((g) => this.emit('gyro', g));
            nexus_parsers_1.parsePPG(v).map((p) => this.emit('ppg', p));
        });
        // Biometrics
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, c.INSAI_SERVICE, c.INSAI_TX_CHARACTERISTIC, (v) => {
            var _a;
            // Nexus doesn't have distinct characteristics for each channel
            const buffer = new Uint8Array(v.buffer);
            const samples = nexus_utils_1.decodeEEGSamples(buffer.slice(0, buffer.length - 4), (_a = this.eegConfig) === null || _a === void 0 ? void 0 : _a.gains[0]);
            samples.map((_, ch) => { var _a; return this.emit('eeg', nexus_parsers_1.parseEEG(ch, v, (_a = this.eegConfig) === null || _a === void 0 ? void 0 : _a.gains[ch])); });
        });
        if (config) {
            await this.setConfig(device);
        }
        else {
            await nexus_utils_1.sendCommand(device.deviceId, 1);
        }
        this.active.next(true);
    }
}
exports.NexusDevice = NexusDevice;
//# sourceMappingURL=nexus.js.map